import { render, staticRenderFns } from "./RedeemForm.vue?vue&type=template&id=736a83cc&scoped=true"
import script from "./RedeemForm.vue?vue&type=script&lang=js"
export * from "./RedeemForm.vue?vue&type=script&lang=js"
import style0 from "./RedeemForm.vue?vue&type=style&index=0&id=736a83cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736a83cc",
  null
  
)

export default component.exports